import { useParams } from "react-router-dom";
import { usePagination, useSorting } from "@/hooks";
import { GetDebitRecordsParams } from "@/redux/apis/payment/record/types";

export const useGetDebitRecordsParams = () => {
  const { page, pageSize } = usePagination();
  const { sortKey, direction } = useSorting();
  const { id } = useParams();

  const params: GetDebitRecordsParams = {
    id: id ?? "",
    page,
    page_size: pageSize,
    sort: sortKey,
    direction,
  };

  return { params, page, pageSize, sort: sortKey, direction };
};
